import hiLocale from 'element-ui/lib/locale/lang/zh-CN' //引入element语言包 印地语
const hi = {
  posterPage: {
    title1:'सदस्यता सुविधा जल्द ही ऑनलाइन होगी!',
    title2:'सदस्यता नवीनीकरण, विशेषाधिकार उन्नयन!',
    title3:'विशेष छूट, नवीकरण और अधिक किफायती',
    title4:'एक्सचेंज कोड प्राप्त करें, आप उपकरण खरीदने वाले विक्रेताओं से परामर्श कर सकते हैं',
    title5:'प्राथमिकता अनुभव सुविधाएं',
    function1:'कार्य विवरण:',
    function2:'बुनियादी सेवाओं का नवीनीकरण (एक साथ अनुवादक, सम्मेलन सहायक, स्मार्ट सहायक)',
    function3:'मूल्यवर्धित सेवा सदस्यता (ऑफलाइन अनुवाद, ऑडियो वीडियो कॉल अनुवाद)',
  },
  RedemptionCodePage: {
    RedemptionCode: 'रिडेम्प्शन कोड',
    ValueAddedServices: 'मान जोड़े गए सेवा',
    UpgradedExperience: 'एक्स्क्लुसिव मूल्य जोड़े लाभ, अद्यतनित अनुभव',
    OfflineTranslation: 'ऑफलाइन अनुवाद',
    NoInternet: 'इंटरनेट कनेक्शन, तुरंत अनुवाद, सुरक्षित और विश्वासी के लिए कोई जरूरत नहीं',
    GoToSubscribe: 'सदस्यता जाएँ',
    AudioAndVideoCall: 'ऑडियो/वीडियो कॉल',
    RealTimeCall: 'वास्तविक समय आवाज अनुवाद और संपर्क पहुँच पहुँच',
    BaseService: 'मूल सेवा',
    AIAssistant: 'फंक्शन्स: एक सामान्य इंटरप्रेटिंग, कंफ़ेंरेशन सहायक, AI सहायक',
    LanguagesSetting:'भाषा सेटिंग्स',
    languages1:'सरलीकृत चीनी',
    languages2:'पारंपरिक चीनी',
    languages3:'अंग्रेजी',
    languages4:'जापानी',
    languages5:'कोरियाई',
    languages6:'रूसी',
    languages7:'स्पेनिश',
    languages8:'फ्रेंच',
    languages9:'जर्मन',
    languages10:'पुर्तगाली',
    languages11:'इतालवी',
    languages12:'तुर्की',
    languages13:'वियतनामी',
    languages14:'इंडोनेशियाई',
    languages15:'हिंदी',
    languages16:'अरबी',
    languages17:'थाई',
    languages18:'फारसी भाषा',
  },
  Login: {
    ToLogin: 'लगइन',
    PhoneLogin: 'फोन संख्या के साथ लॉगिन करें',
    EmailLogin: 'इमेल लागइन',
    PhonePlaceholder: 'कृपया अपना फोन संख्या भरें',
    EmailPlaceholder: 'Enter email',
    Code: 'परीक्षण कोड',
    and: 'और',
    BeforeText: 'एक खाता निर्माण करने के लिए तुम्हारी सहमता और अनुसरण का प्रतिनिधित्व करता है',
    UserAgreement: 'प्रयोक्ता स्वीकार',
    privacy: 'निजी नीति',
    errorMessage: 'सत्यापन कोड त्रुटि',
    readTitle: 'निम्न सहमता के साथ पढ़ने और स्वीकार करें',
    readBefore: 'अपने व्यक्तिगत जानकारी की सुरक्षा सुनिश्चित करने के लिए, कृपया पहले पढ़ने और संमति से मिलें',
    cancel: 'रद्द करें',
    agree: 'स्वीकार करें और जारी रखें',
    error1:'कृपया एक वैध ईमेल पता दर्ज करें',
    error2:'कृपया सही फोन नंबर दर्ज करें',
    error3:'कृपया कोड दर्ज करें',
    success:'सफलतापूर्वक प्रवेश'
  },
  OffLinePage: {
    title: 'ऑफलाइन अनुवाद',
    NoInternet: 'इंटरनेट कनेक्शन, तुरंत अनुवाद, सुरक्षित और विश्वासी के लिए कोई जरूरत नहीं',
    ServiceLife: 'सेवा जीवन',
    forever: 'स्थायी उपयोग',
    describe: 'सदस्यता सूचना',
    describeItem1: '1. ऑफ़लाइन अनुवाद फंक्शन एक बार पैसा, स्थायी उपयोग, और उपयोग अनुमति ब्लूटूथ युक्ति का अनुसरण करती है. यदि आप युक्ति को बदलें, आपको फिर ऑफ़लाइन अनुवाद',
    describeItem2: '2. प्रमाणीकरण कोड सदस्यता पुनरावृत्ति नहीं है.',
    describeItem3: '3. 10 भाषाओं का समर्थन करता है: चीनी, अंग्रेजी, जर्मन, जापानी, कोरियाई, हिंदी, थाई, स्पेनिश, फ्रेंच, रूसी।',
    quantity: 'मात्रा',
    payType: 'पैमेंट विधि',
    card: 'बैंक कार्ड',
    wx: 'वेचैटCity name (optional, probably does not need a translation)',
    GooglePay: 'Google Pay',
    subscribe: 'सदस्यता करें',
    RMB: '¥',
    confirm:'पुष्टि करें',
    cardNumber:'कार्ड संख्या',
    periodOfValidity:'वैधिकता का अवधि',
    safetyCode:'सुरक्षा कोड',
    name:'पूरा नाम',
    yearAndMonth:'साल/महीना',
    message1:'संख्या 0 नहीं हो सकती',
    popTip:'सुझाव',
    popText1:'कृपया ध्यान से पढ़ें और समझें',
    popText2:'ऑफलाइन अनुवाद भुगतान करार',
    popText3:'मैंने पढ़ा है और सहमत हूँ',
    popText4:'पढ़ा और सहमत',
  },
  AudioVideoPage: {
    title: 'ऑडियो/वीडियो कॉल',
    RealTime: 'वास्तविक समय आवाज अनुवाद और संपर्क पहुँच पहुँच',
    describe: 'सदस्यता सूचना',
    describeItem1: '1. ऑडियो और वीडियो कॉल अनुवाद फंक्शन पुनर्चार्ज करने और खरीद करने के लिए मिनट है. कॉल कनेक्ट के समय से मिनट गिनती है और अनुमतियाँ खाता के अनुसरण करें. ',
    describeItem2: '2. खाता पुनरार्चार्ज करने के बाद, कनेक्टिंग और बाइंडिंग अलग उपकरण अभी भी सामान्य रूप में उपयोग किया जा सकता ',
    describeItem3: '3. आडियो और वीडियो कॉल अनुवाद फंक्शन फ़ंक्शन पुनः चार्ज करने के बाद पुन: प्राप्त नहीं कर सकता.',
    payType: 'पैमेंट विधि',
    card: 'बैंक कार्ड',
    wx: 'वेचैटCity name (optional, probably does not need a translation)',
    GooglePay: 'Google Pay',
    subscribe: 'सदस्यता करें',
    RMB: '¥',
    sale: 'डिस्कॉन्ट',
    confirm:'पुष्टि करें',
    time1:'सेकंड',
    time2:'मिनट',
    time3:'घंटे',
    time4:'दिन',
    time5:'महीने',
    time6:'वर्ष',
  },
  OffLineResult: {
    title1: 'ऑफलाइन अनुवाद',
    title2: 'ऑडियो/वीडियो कॉल',
    title3: 'मूल सेवा',
    success: 'सदस्यता सफल',
    fail: 'सदस्यता विफल',
    stock:'विनिमय कोड तैयार है',
    saveTitle: 'विकास कोड सहेजें और इसे पुनरावृत्ति करने के लिए अनुप्रयोग में जाओ',
    code: 'रिडेम्प्शन कोड',
    tip1: 'यह कोड केवल ऑफ़लाइन अनुवाद फंक्शन पुनरावृत्ति करने के लिए इस्तेमाल किया जाता है',
    tip2: 'यह कोड सिर्फ ऑडियो/वीडियो कॉल अनुवाद फंक्शन पुनरावृत्ति करने के लिए प्रयोग किया जाता ह',
    tip3: 'यह कोड केवल मूल सेवा पुनरावृत्ति फंक्शन्स पुनरावृत्ति करने के लिए प्रयोग किया जाता है',
    save: 'सहेजें',
    time: 'सदस्यता समय:',
    copy: 'नकल',
    copySuccess: 'सफलता प्रतिक्रिया कर रहा है',
    loading:'लोड हो रहा है',
    paySuccess:'भुगतान सफल'
  },
  RedemptionList: {
    title: 'मेरा विमोचन कोड',
    view: 'दृश्य',
    time: 'सदस्यता समय:',
  },
  MyRedemption: {
    title: 'मेरा विमोचन कोड',
    code: 'रिडेम्प्शन कोड',
    time: 'सदस्यता समय:',
    copy: 'नकल',
    tip1: 'यह कोड केवल ऑफ़लाइन अनुवाद फंक्शन पुनरावृत्ति करने के लिए इस्तेमाल किया जाता है',
    tip2: 'यह कोड सिर्फ ऑडियो/वीडियो कॉल अनुवाद फंक्शन पुनरावृत्ति करने के लिए प्रयोग किया जाता ह',
    tip3: 'यह कोड केवल मूल सेवा पुनरावृत्ति फंक्शन्स पुनरावृत्ति करने के लिए प्रयोग किया जाता है',
    save: 'सहेजें',
    success:"आपरेशन सफल"
  },
  basePage:{
    error1:'उत्पाद जानकारी नहीं मिली',
    message1:'कृपया उत्पाद चुनें',
    title:'मूल सेवा',
    function:'फंक्शन्स: एक सामान्य इंटरप्रेटिंग, कंफ़ेंरेशन सहायक, AI सहायक',
    describe: 'सदस्यता सूचना',
    describe1:'1. मूल सेवा के पुनरावृत्ति के बाद जैसे अनुवाद और कंफ्रेन्स सेवा के अनुवाद के अनुवाद के अनुवाद के अनुसार, वैध अवधि उपकरण के अनुसार है. यदि ',
    describe2:'2. पुनरावृत्ति के बाद मूल सेवा पुनरावृत्ति नहीं किया जा सकता.',
    payType: 'पैमेंट विधि',
    card: 'बैंक कार्ड',
    wx: 'वेचैटCity name (optional, probably does not need a translation)',
    GooglePay: 'Google Pay',
    subscribe: 'सदस्यता करें',
    RMB: '¥',
    sale: 'डिस्कॉन्ट',
    month:'चन्द्रमा',
    confirm:'पुष्टि करें',
    month1:'1 महीना',
    month2:'आधा साल',
    month3:'1 साल'
  },
  ...hiLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default hi;
